
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21.9599 11.05C22.5399 17.31 17.3199 22.53 11.0599 21.95C6.62988 21.54 2.93988 18.1 2.15988 13.72C1.89988 12.3 1.96988 10.94 2.27988 9.67997C2.41988 9.09997 3.03988 8.77997 3.58988 8.97997C4.05988 9.14997 4.33988 9.64997 4.21988 10.14C4.01988 10.96 3.94988 11.84 4.02988 12.75C4.39988 16.79 7.91988 20 11.9799 20.01C16.7699 20.02 20.5899 15.8 19.9199 10.89C19.4099 7.18997 16.2599 4.26997 12.5299 4.02997C11.6999 3.96997 10.8999 4.04997 10.1499 4.22997C9.65988 4.33997 9.15988 4.06997 8.98988 3.58997C8.78988 3.02997 9.10988 2.41997 9.67988 2.27997C11.4699 1.84997 13.4299 1.86997 15.4599 2.64997C19.0199 3.99997 21.6099 7.26997 21.9599 11.05ZM5.49988 3.99997C4.66988 3.99997 3.99988 4.66997 3.99988 5.49997C3.99988 6.32997 4.66988 6.99997 5.49988 6.99997C6.32988 6.99997 6.99988 6.32997 6.99988 5.49997C6.99988 4.66997 6.32988 3.99997 5.49988 3.99997ZM10.9999 15V8.99997C10.9999 8.44997 10.5499 7.99997 9.99988 7.99997C9.44988 7.99997 8.99988 8.44997 8.99988 8.99997V15C8.99988 15.55 9.44988 16 9.99988 16C10.5499 16 10.9999 15.55 10.9999 15ZM14.9999 15V8.99997C14.9999 8.44997 14.5499 7.99997 13.9999 7.99997C13.4499 7.99997 12.9999 8.44997 12.9999 8.99997V15C12.9999 15.55 13.4499 16 13.9999 16C14.5499 16 14.9999 15.55 14.9999 15Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-motion-photos-paused`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconMotionPhotosPaused

    ```js
    <b-new-b-icon-motion-photos-paused />
    ```
</docs>


